import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { OivCoreSharedFacade } from '@mobi/oiv-viewer-utils-ng-jslib';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';

export interface SearchResultItem {
    referenceId: string;
    breadcrumb: string;
    title: string;
    description: string;
    urlPath: string;
}
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'oiv-viewer-search-result-item',
    imports: [MobiUiIconComponent, NgClass],
    templateUrl: './search-result-item.component.html',
    styleUrl: './search-result-item.component.scss',
})
export class SearchResultItemComponent {
    #router = inject(Router);

    #coreSharedFacade = inject(OivCoreSharedFacade);
    resultItem = input<SearchResultItem>({
        referenceId: '',
        breadcrumb: '',
        title: '',
        description: '',
        urlPath: '',
    });

    isAIReference = input<boolean>(false);

    protected highlightSearchContent(description: string): string {
        const regex = /<em>(.*?)<\/em>/g;
        let highlightedDescription = description;
        let match;
        while ((match = regex.exec(description)) !== null) {
            const word = match[1];
            highlightedDescription = highlightedDescription.replace(
                `<em>${word}</em>`,
                `<span class="mobi-ui-font-bold">${word}</span>`,
            );
        }
        return highlightedDescription;
    }

    navigateToResult() {
        const url = this.handleRemoveSelectedFirstResultParam(this.resultItem().urlPath);
        this.#coreSharedFacade.closeOverlay();
        this.#router.navigateByUrl(url);
    }

    handleRemoveSelectedFirstResultParam(url: string): string {
        const baseUrl = url.split('?')[0];
        const fragment = url.split('#')[1] ? `#${url.split('#')[1]}` : '';
        const queryParam = url.split('#')[0].split('?')[1];
        const newQueryParam = queryParam
            .split('&')
            .filter(param => param !== 'selectFirstResult=true')
            .join('&');
        return `${baseUrl}?${newQueryParam}${fragment}`;
    }
}
